import React from "react";
import "../../commoncss/Common.css";
import { Chart } from "react-google-charts";

export const Linedata = [
  ["Date Range", "Total Deposit", "Withdrawal"],
  ["1-18", 1000, 400],
  ["18-31", 1170, 460],
  ["1-10", 660, 1120],
  ["10-17", 1030, 540],
];

export const Lineoptions = {
  title: "Analytics",
  titleTextStyle: {
    color: "#f8fafc",
    fontSize: 16,
    fontName: "Arial",
  },
  curveType: "function",
  legend: {
    position: "bottom",
    textStyle: {
      color: "#f8fafc",
    },
  },
  backgroundColor: "#1e293b",
  chartArea: {
    backgroundColor: "#1e293b",
    left: 60,
    top: 50,
    width: "80%",
    height: "70%",
  },
  hAxis: {
    title: "Date Range",
    textStyle: {
      color: "#f8fafc",
    },
    titleTextStyle: {
      color: "#f8fafc",
    },
    gridlines: {
      color: "#334155",
    },
    baselineColor: "#334155",
  },
  vAxis: {
    title: "Amount ($)",
    textStyle: {
      color: "#f8fafc",
    },
    titleTextStyle: {
      color: "#f8fafc",
    },
    gridlines: {
      color: "#334155",
    },
    baselineColor: "#334155",
  },
  series: {
    0: { color: "#4f46e5" }, // Total Deposit
    1: { color: "#7c3aed" }, // Withdrawal
  },
};

export const LineData2 = [
  [
    { type: "number", label: "Time Period" },
    { type: "number", label: "Performance Values" },
    { id: "i0", type: "number", role: "interval" },
    { id: "i1", type: "number", role: "interval" },
    { id: "i2", type: "number", role: "interval" },
    { id: "i2", type: "number", role: "interval" },
    { id: "i2", type: "number", role: "interval" },
    { id: "i2", type: "number", role: "interval" },
  ],
  [1, 100, 90, 110, 85, 96, 104, 120],
  [2, 120, 95, 130, 90, 113, 124, 140],
  [3, 130, 105, 140, 100, 117, 133, 139],
  [4, 90, 85, 95, 85, 88, 92, 95],
  [5, 70, 74, 63, 67, 69, 70, 72],
  [6, 30, 39, 22, 21, 28, 34, 40],
  [7, 80, 77, 83, 70, 77, 85, 90],
  [8, 100, 90, 110, 85, 95, 102, 110],
];

export const LineOptions2 = {
  title: "Performance Metrics with Confidence Intervals",
  titleTextStyle: {
    color: "#f8fafc",
    fontSize: 16,
    fontName: "Arial",
  },
  curveType: "function",
  series: [{ color: "#D9544C" }],
  intervals: {
    style: "bars",
    color: "#D9544C",
  },
  legend: "none",
  backgroundColor: "#1e293b",
  chartArea: {
    backgroundColor: "#1e293b",
    left: 60,
    top: 50,
    width: "80%",
    height: "70%",
  },
  hAxis: {
    title: "Time Period",
    textStyle: {
      color: "#f8fafc",
    },
    titleTextStyle: {
      color: "#f8fafc",
    },
    gridlines: {
      color: "#334155",
    },
    baselineColor: "#334155",
  },
  vAxis: {
    title: "Performance Values",
    textStyle: {
      color: "#f8fafc",
    },
    titleTextStyle: {
      color: "#f8fafc",
    },
    gridlines: {
      color: "#334155",
    },
    baselineColor: "#334155",
  },
};

export const MultiLinedata = [
  ["Date", "Withdrawal Ratio (%)", "Deposit Ratio (%)"],
  [new Date(2023, 0, 2), 45.5, 54.5],
  [new Date(2023, 0, 8), 48.4, 51.6],
  [new Date(2023, 0, 12), 42.5, 57.5],
  [new Date(2023, 0, 18), 52.9, 47.1],
  [new Date(2023, 0, 24), 39.3, 60.7],
  [new Date(2023, 0, 31), 35.0, 65.0],
  [new Date(2023, 1, 1), 43.6, 56.4],
  [new Date(2023, 1, 4), 47.3, 52.7],
  [new Date(2023, 1, 6), 55.4, 44.6],
  [new Date(2023, 1, 8), 62.4, 37.6],
  [new Date(2023, 1, 10), 71.1, 28.9],
  [new Date(2023, 1, 12), 68.2, 31.8],
];

export const MultiLineoptions = {
  backgroundColor: "#1e293b",
  chartArea: {
    backgroundColor: "#1e293b",
    left: 80,
    top: 50,
    width: "75%",
    height: "70%",
  },
  series: {
    0: { color: "#4f46e5" },
    1: { color: "#7c3aed" },
  },
  hAxis: {
    title: "Date",
    textStyle: { color: "#f8fafc" },
    titleTextStyle: { color: "#f8fafc" },
    gridlines: { color: "#334155" },
    baselineColor: "#334155",
    format: "MMM dd",
  },
  vAxis: {
    title: "Percentage (%)",
    textStyle: { color: "#f8fafc" },
    titleTextStyle: { color: "#f8fafc" },
    gridlines: { color: "#334155" },
    baselineColor: "#334155",
    format: "#'%'",
  },
  legend: {
    position: "bottom",
    textStyle: { color: "#f8fafc" },
  },
  titleTextStyle: {
    color: "#f8fafc",
    fontSize: 16,
  },
  title: "Daily Withdrawal/Deposit Ratios",
};

const Admindashboard = () => {
  return (
    <>
      <div className="agent_wrapper">
        <div className="top_search_fields">
          <div className="flex">
            <table className="options_table">
              <tr>
                <td>
                  <label>From : </label>
                </td>
                <td>
                  <input type="date" />
                </td>
              </tr>
              <tr>
                <td>
                  <label>To : </label>
                </td>
                <td>
                  <input type="date" />
                </td>
              </tr>
            </table>
          </div>
          <div className="btn_container">
            <button>Apply</button>
          </div>
        </div>
        <div className="chart_container">
          <Chart
            chartType="LineChart"
            width="100%"
            height="400px"
            data={Linedata}
            options={Lineoptions}
          />
          <Chart
            chartType="LineChart"
            width="100%"
            height="400px"
            data={LineData2}
            options={LineOptions2}
          />
        </div>
        <div className="chart_container container_2">
          <Chart
            chartType="LineChart"
            width="100%"
            height="400px"
            data={MultiLinedata}
            options={MultiLineoptions}
          />
        </div>
      </div>
    </>
  );
};

export default Admindashboard;
